<div class="calendar-controls">
  <div class="calendar-navigations">
    <h4 class="calendar-month" (click)="changeMonth(0)">{{ currentMonthTitle }}</h4>
    <div class="calendar-month-nav align-center">
      <mat-icon (click)="changeMonth(-1)">keyboard_double_arrow_left</mat-icon>
      <div class="circle" (click)="changeMonth(0)"></div>
      <mat-icon (click)="changeMonth(1)"> keyboard_double_arrow_right</mat-icon>
    </div>
  </div>
  <div class="legend-container">
    @if (!isCalendarHome()) {
      <div class="legend-row-logged">
        <div class="logged">
          <span class="label">logged time</span>
          <div class="legend"></div>
        </div>
        <div class="missing">
          <span class="label">missing Logged time</span>
          <div class="legend"></div>
        </div>
      </div>
    }
    <div class="legend-row">
      @for (type of leaveTypes; track type) {
        <div class="legend-column">
          <div [ngClass]="type.toLowerCase() + '-color-contrast'">
            <mat-icon>{{ type | vacationTypeToIcon }}</mat-icon>
          </div>
          @if (isCalendarHome()) {
            <div class="legend-title" [ngClass]="type.toLowerCase() + '-color'">
              {{ `VACATION_TYPES.${type}` | translate }}
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
